import type {RecoveryAccount} from './suiteRecovery'

/** A preference is never authority. Every publication still uses the original
 * actor/workspace fence, current ACLs and the canonical revision compare-and-set.
 * Store no file names, passages, tokens or editor bytes in this preference. */
function key(account:RecoveryAccount,fileId:string){return 'folio-autosave.v1:'+JSON.stringify([account.tenant_id,account.actor_id,fileId])}
export function autoSavePreference(account:RecoveryAccount,fileId:string){
 try{return localStorage.getItem(key(account,fileId))==='on'}catch{return false}
}
export function rememberAutoSave(account:RecoveryAccount,fileId:string,enabled:boolean){
 try{if(enabled)localStorage.setItem(key(account,fileId),'on');else localStorage.removeItem(key(account,fileId))}
 catch{throw Error('AutoSave preference could not be saved on this browser.')}
}
export const accountFence=(account:RecoveryAccount)=>JSON.stringify([account.tenant_id,account.actor_id])
